import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import TipHeartAnimation from './TipHeartAnimation';

export const DeliveryTipsSelectButton = React.forwardRef((props, ref) => {
  const {
    tipPercentageButtonId,
    value,
    onClickHandler,
    disabled,
    children,
    checked,
    labelText,
    isAnimating,
    onAnimationComplete,
  } = props;

  return (
    <StyledSelectButton className={checked ? 'checked' : ''}>
      <input
        id={tipPercentageButtonId}
        type="radio"
        value={value}
        name="percentage"
        ref={ref}
        onChange={onClickHandler}
        disabled={disabled}
        checked={checked}
      />
      <label htmlFor={tipPercentageButtonId}>{children}</label>
      <label htmlFor={tipPercentageButtonId}>{labelText}</label>
      <TipHeartAnimation
        data-testid="tip-heart-animation"
        isAnimating={isAnimating}
        onComplete={onAnimationComplete}
      />
    </StyledSelectButton>
  );
});

export const StyledSelectButton = styled('div')`
  min-width: 85px;
  min-height: 48px;
  position: relative;
  margin: 5px;
  border: solid 1px #5b6770;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: #fff;
  overflow: hidden;
  & label {
    cursor: pointer;
    z-index: 90;
    width: 100%;
    height: 100%;
    color: ${(props) => props.theme.text};
    font-size: 14px;
    & svg {
      height: 18px;
      fill: ${(props) => props.theme.text};
      margin: 0;
      vertical-align: middle;
    }
    &:last-of-type {
      font-size: 11px;
    }
  }
  &.checked {
    border: solid 2px #dd0031;
    & label {
      color: #dd0031;
    }
    & svg {
      fill: ${(props) => props.theme.tertiary};
    }
  }
  & input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
  }
  & input[type='radio'] {
    opacity: 0.011;
    z-index: 100;
    &:disabled {
      cursor: auto;
    }
    &:disabled + label {
      background: ${(props) => props.theme.disabled};
      color: ${(props) => props.theme.text};
      border-color: ${(props) => props.theme.text};
      cursor: auto;
    }
  }
`;

DeliveryTipsSelectButton.propTypes = {
  tipPercentageButtonId: PropTypes.string,
  value: PropTypes.number,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  children: PropTypes.node,
  labelText: PropTypes.string,
  isAnimating: PropTypes.bool,
  onAnimationComplete: PropTypes.func,
};

DeliveryTipsSelectButton.defaultProps = {
  tipPercentageButtonId: '',
  value: 0,
  onClickHandler: () => {},
  disabled: false,
  checked: false,
  children: null,
  labelText: '',
  isAnimating: false,
  onAnimationComplete: () => {},
};

export default DeliveryTipsSelectButton;
